import http, { formatApiErrorMessage, request } from './http';
import type { CalculatorFormula } from '@/types/calculatorFormula';

export interface CustomFormulaSharePreview {
  publicId: string;
  formulaName: string;
  sharerName: string;
  authorName?: string;
  shareMessage?: string | null;
  formula: CalculatorFormula;
  saved: boolean;
  savedFormulaId?: string | null;
}

export interface CustomFormulaShareSaveResult {
  formulaId: string;
  formulaName: string;
  alreadySaved: boolean;
}

function unwrapResult<T>(res: { success?: boolean; message?: string; data?: T }): T {
  if (res.success === false) {
    throw new Error(res.message?.trim() || '请求失败');
  }
  return res.data as T;
}

export async function createCustomFormulaShares(body: {
  formulaId: string;
  recipientUserIds: number[];
  message?: string;
}): Promise<Array<{ publicId: string; recipientUserId: number }>> {
  const res = await request<{
    success?: boolean;
    message?: string;
    data?: Array<{ publicId: string; recipientUserId: number }>;
  }>(http.post('/ai/calculator/formula-shares', body));
  return unwrapResult(res) ?? [];
}

export async function fetchCustomFormulaSharePreview(publicId: string): Promise<CustomFormulaSharePreview> {
  const res = await request<{
    success?: boolean;
    message?: string;
    data?: CustomFormulaSharePreview;
  }>(http.get(`/ai/calculator/formula-shares/${encodeURIComponent(publicId)}`));
  return unwrapResult(res);
}

export async function saveCustomFormulaShareToMine(publicId: string): Promise<CustomFormulaShareSaveResult> {
  const res = await request<{
    success?: boolean;
    message?: string;
    data?: CustomFormulaShareSaveResult;
  }>(http.post(`/ai/calculator/formula-shares/${encodeURIComponent(publicId)}/save-to-mine`));
  return unwrapResult(res);
}

export { formatApiErrorMessage };
